<template>
	<fieldset id="fs-inputmethod" class="pt-3 pb-3">
		<div class="container pt-5 pb-2">
			<div class="fieldgroup">
				<NPepInputs v-if="showNPepInputs" />

				<RPepInputs v-if="showRPepInputs" />

				<div
					v-if="formData.buildingType !== 'multi_family'"
					class="row no-gutters"
				>
					<div class="col-3">
						<FormInput
							:dataKey="inputConfig.fieldName"
							inputClass="field-icon"
							fieldWrapClass="size-big"
						>
							<template v-slot:icon>
								<i
									:class="['fa-solid', 'fa-2xl', 'pl-2', inputConfig.iconName]"
									style="color: #8c8c8c;"
								/>
							</template>
						</FormInput>
					</div>
				</div>
			</div>
		</div>
	</fieldset>
</template>

<script>
import formData from '@/components/Sizer/form-data-store'
import config from './occupancy-inputs-config.js'
import NPepInputs from './components/NPepInputs'
import RPepInputs from './components/RPepInputs'
import FormInput from '@/components/FormInput'

export default {
	name: 'OccupancyInputs',

	components: {
		NPepInputs,
		RPepInputs,
		FormInput,
	},

	data: () => ({
		formData,
	}),

	computed: {
		inputConfig () {
			return config[this.formData.buildingType]
		},

		showNPepInputs () {
			const { buildingType, inputmethod } = formData

			return buildingType === 'multi_family' && inputmethod === 'NPep'
		},

		showRPepInputs () {
			const { buildingType, inputmethod } = formData

			return buildingType === 'multi_family' && inputmethod === 'RPep'
		}
	},
}
</script>
